@if (isMatMenu) {
  <button mat-menu-item
          data-test="dms-openFolderInfo-button"
          [matTooltip]="title"
          [matTooltipDisabled]="isMatMenu"
          (click)="openFolderInfo()">
    <i [hidden]="labelOnly" class="icon fa-fw fa fa-info-circle"></i>
    <label [hidden]="iconOnly" class="m-0">{{ title }}</label>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             data-test="dms-openFolderInfo-button"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [ngClass]="btnClass"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="openFolderInfo()">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fa fa-info-circle"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fa fa-info-circle"></i>
      </ng-template>
    }
  </sk-button>
}
